import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import {
  Zap, Users, Briefcase, PenTool, Smartphone,
  ChevronDown, ChevronUp, Check, Menu, X as CloseIcon, History
} from 'lucide-react';
import axios from 'axios';
import MotionDemo from '../components/MotionDemo';

const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : 'https://devisfast-backend.onrender.com/api';

function PhoneMockup() {
  return (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center' }}>
      <div style={{
        width: 300,
        background: 'linear-gradient(145deg,#A0A0A0 0%,#8E8E93 30%,#6E6E6E 70%,#5A5A5E 100%)',
        borderRadius: 48,
        padding: 10,
        boxShadow: '0 30px 80px rgba(30,64,175,0.4), 0 15px 40px rgba(30,64,175,0.2)',
      }}>
        <div style={{ background:'#0f0f17', borderRadius: 38, overflow:'hidden' }}>
          <div style={{ background:'#0f0f17', padding:'12px 20px 6px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <span style={{ color:'#fff', fontSize:12, fontWeight:700 }}>9:41</span>
            <div style={{ width:90, height:26, background:'#000', borderRadius:13 }} />
            <div style={{ width:36, height:14, background:'#fff', borderRadius:3, position:'relative' }}>
              <div style={{ position:'absolute', inset:2, width:'75%', background:'#22c55e', borderRadius:2 }} />
            </div>
          </div>
          <div style={{ padding:'8px 14px 20px' }}>
            <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:14 }}>
              <div style={{ width:28, height:28, background:'#2563eb', borderRadius:7, display:'flex', alignItems:'center', justifyContent:'center' }}>
                <span style={{ color:'#fff', fontSize:12, fontWeight:900 }}>⚡</span>
              </div>
              <span style={{ color:'#f1f5f9', fontSize:13, fontWeight:800 }}>DEVISFAST</span>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:12 }}>
              <div style={{ background:'#1a1a24', borderRadius:12, padding:'10px 12px' }}>
                <div style={{ color:'#64748b', fontSize:9, marginBottom:4 }}>Ce mois</div>
                <div style={{ color:'#f1f5f9', fontSize:18, fontWeight:800 }}>3 450€</div>
                <div style={{ color:'#22c55e', fontSize:10 }}>+12%</div>
              </div>
              <div style={{ background:'#1a1a24', borderRadius:12, padding:'10px 12px' }}>
                <div style={{ color:'#64748b', fontSize:9, marginBottom:4 }}>En attente</div>
                <div style={{ color:'#f1f5f9', fontSize:18, fontWeight:800 }}>2 150€</div>
                <div style={{ color:'#eab308', fontSize:10 }}>4 devis</div>
              </div>
            </div>
            <div style={{ color:'#64748b', fontSize:9, fontWeight:700, marginBottom:8, textTransform:'uppercase', letterSpacing:1 }}>Derniers devis</div>
            {[
              { name:'M. Dupont', desc:'Rénovation salle de bain', status:'Signé', color:'#22c55e', bg:'#052e16' },
              { name:'Mme Martin', desc:'Peinture salon', status:'En attente', color:'#eab308', bg:'#422006' },
              { name:'LECLERC Jean', desc:'Taille haies & arbustes', status:'Brouillon', color:'#94a3b8', bg:'#1e293b' },
            ].map((d,i) => (
              <div key={i} style={{ background:'#1a1a24', borderRadius:10, padding:'10px 12px', marginBottom:6, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <div>
                  <div style={{ color:'#f1f5f9', fontSize:12, fontWeight:600 }}>{d.name}</div>
                  <div style={{ color:'#64748b', fontSize:10, marginTop:2 }}>{d.desc}</div>
                </div>
                <div style={{ background:d.bg, color:d.color, fontSize:9, fontWeight:700, padding:'3px 8px', borderRadius:10 }}>{d.status}</div>
              </div>
            ))}
            <div style={{ display:'flex', justifyContent:'center', marginTop:12 }}>
              <div style={{ width:90, height:4, background:'rgba(255,255,255,0.3)', borderRadius:2 }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProofPhoneMockup() {
  return (
    <div style={{ display:'flex', justifyContent:'center' }}>
      <div style={{
        width: 280,
        background: 'linear-gradient(145deg,#A0A0A0 0%,#8E8E93 30%,#6E6E6E 70%,#5A5A5E 100%)',
        borderRadius: 44,
        padding: 9,
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
      }}>
        <div style={{ background:'#000', borderRadius:36, overflow:'hidden' }}>
          <div style={{ background:'#0f0f17', padding:'10px 16px 4px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <span style={{ color:'#fff', fontSize:11, fontWeight:700 }}>20:24</span>
            <div style={{ width:80, height:22, background:'#000', borderRadius:11 }} />
            <span style={{ color:'#fff', fontSize:9 }}>●●</span>
          </div>
          <img
            src="https://res.cloudinary.com/dzv8einm3/image/upload/v1778361141/IMG_8380_3_xhsyng.png"
            alt="DevisFast - Photos chantier dans le devis"
            style={{ width:'100%', display:'block' }}
          />
        </div>
      </div>
    </div>
  );
}

const LandingPage = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios.get(`${API}/reviews/approved`)
      .then(res => setReviews(res.data))
      .catch(() => {});
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  const faqItems = [
    { q:"DevisFast est-il fait pour les auto-entrepreneurs ?", a:"Oui, c'est exactement la cible. Artisans solo et indépendants qui veulent aller vite sans logiciel compliqué." },
    { q:"Et la facture électronique 2026 ? Je dois faire quoi ?", a:"DevisFast est conçu pour les artisans qui travaillent principalement avec des particuliers. Pour vos factures à des particuliers, aucune facture électronique n'est exigée par la réforme. Pour vos factures à des professionnels, l'obligation s'applique à partir du 1er septembre 2027 pour les TPE." },
    { q:"Est-ce que je peux l'utiliser sur téléphone ?", a:"Oui, c'est même conçu pour ça. Interface pensée pour être utilisée sur chantier, avec les pouces." },
    { q:"Est-ce compliqué à prendre en main ?", a:"Non. Si vous savez envoyer un SMS, vous savez utiliser DevisFast." },
    { q:"Comment fonctionne l'essai gratuit ?", a:"14 jours pour tester DevisFast gratuitement, sans carte bancaire demandée à l'inscription. Pour continuer après J+14, vous ajoutez votre carte (9,99€/mois ou 89€/an). Résiliable en 2 clics." },
    { q:"Faut-il entrer une carte bancaire pour démarrer ?", a:"Non. L'inscription se fait avec email et mot de passe, c'est tout. Vous accédez immédiatement à l'application pendant 14 jours." },
    { q:"Comment fonctionne la signature électronique ?", a:"Vous envoyez le devis par email. Votre client signe avec le doigt depuis son téléphone. Vous recevez la confirmation immédiatement." },
    { q:"Les mentions obligatoires sont-elles intégrées ?", a:"Oui. Numéro de devis, TVA, conditions de paiement, validité — toutes les mentions utiles sont générées automatiquement." },
    { q:"Combien coûte DevisFast ?", a:"9,99€/mois ou 89€/an (soit 7,42€/mois) après la période d'essai de 14 jours. Sans engagement, résiliable en 2 clics." },
    { q:"Puis-je résilier à tout moment ?", a:"Oui, sans frais. Résiliation en 2 clics depuis votre espace personnel." },
  ];

  const metiers = [
    {icon:"🔧",name:"Plombier"},{icon:"🖌️",name:"Peintre"},{icon:"⚡",name:"Électricien"},
    {icon:"🧱",name:"Maçon"},{icon:"🪵",name:"Menuisier"},{icon:"🌿",name:"Jardinier"},
    {icon:"🧹",name:"Femme de ménage"},{icon:"🐶",name:"Pet-sitter"},
    {icon:"🛠️",name:"Multiservices"},{icon:"📋",name:"Auto-entrepreneur"},
  ];

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white" style={{fontFamily:"'DM Sans', sans-serif"}}>

      <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0f]/95 backdrop-blur-md border-b border-white/5">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-9 h-9 bg-[#2563EB] rounded-xl flex items-center justify-center"><Zap className="w-5 h-5 text-white"/></div>
            <span className="text-xl font-bold" style={{fontFamily:"'Syne', sans-serif"}}>DEVISFAST</span>
          </Link>
          <nav className="hidden md:flex items-center gap-6">
            <button onClick={()=>scrollToSection('fonctionnalites')} className="text-gray-400 hover:text-white transition-colors text-sm">Fonctionnalités</button>
            <button onClick={()=>scrollToSection('tarifs')} className="text-gray-400 hover:text-white transition-colors text-sm">Tarifs</button>
            <button onClick={()=>scrollToSection('faq')} className="text-gray-400 hover:text-white transition-colors text-sm">FAQ</button>
          </nav>
          <div className="hidden md:flex items-center gap-3">
            <Link to="/login"><Button variant="ghost" className="text-gray-400 hover:text-white" data-testid="header-login-btn">Connexion</Button></Link>
            <Link to="/login?tab=inscription"><Button className="bg-[#2563EB] hover:bg-[#1d4ed8] text-white rounded-full px-5" data-testid="header-signup-btn">Essayer gratuitement</Button></Link>
          </div>
          <button className="md:hidden p-2 text-gray-400" onClick={()=>setMobileMenuOpen(!mobileMenuOpen)}>
            {mobileMenuOpen?<CloseIcon className="w-6 h-6"/>:<Menu className="w-6 h-6"/>}
          </button>
        </div>
      </header>

      {mobileMenuOpen&&(
        <div className="md:hidden fixed inset-0 z-[60] bg-[#0a0a0f]">
          <button onClick={()=>setMobileMenuOpen(false)} className="absolute top-4 right-4 p-2 text-gray-400"><CloseIcon className="w-8 h-8"/></button>
          <div className="flex items-center gap-2 px-6 pt-5">
            <div className="w-9 h-9 bg-[#2563EB] rounded-xl flex items-center justify-center"><Zap className="w-5 h-5 text-white"/></div>
            <span className="text-xl font-bold" style={{fontFamily:"'Syne', sans-serif"}}>DEVISFAST</span>
          </div>
          <nav className="flex flex-col items-center justify-center h-[calc(100%-180px)] gap-8 px-6">
            <button onClick={()=>scrollToSection('fonctionnalites')} className="text-white text-2xl font-medium py-3 hover:text-[#2563EB]">Fonctionnalités</button>
            <button onClick={()=>scrollToSection('tarifs')} className="text-white text-2xl font-medium py-3 hover:text-[#2563EB]">Tarifs</button>
            <button onClick={()=>scrollToSection('faq')} className="text-white text-2xl font-medium py-3 hover:text-[#2563EB]">FAQ</button>
            <hr className="w-24 border-white/20 my-4"/>
            <Link to="/login" className="text-gray-400 text-lg" onClick={()=>setMobileMenuOpen(false)}>Connexion</Link>
          </nav>
          <div className="absolute bottom-0 left-0 right-0 p-6 bg-[#0a0a0f]">
            <Link to="/login?tab=inscription" onClick={()=>setMobileMenuOpen(false)}>
              <Button className="w-full h-14 bg-[#2563EB] hover:bg-[#1d4ed8] text-white text-lg font-bold rounded-full">Essayer gratuitement</Button>
            </Link>
          </div>
        </div>
      )}

      {/* HERO */}
      <section className="pt-24 md:pt-32 pb-16 md:pb-24 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-center md:text-left">
              <div className="inline-flex items-center gap-2 bg-[#2563EB]/10 border border-[#2563EB]/30 rounded-full px-4 py-2 mb-6">
                <span className="text-[#2563EB] text-sm font-medium">Fait pour les artisans qui bossent seuls</span>
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" style={{fontFamily:"'Syne', sans-serif"}}>
                L'application de devis et factures pour les artisans qui travaillent seuls
              </h1>
              <p className="text-lg md:text-xl text-gray-400 mb-8 max-w-xl mx-auto md:mx-0">
                Quelques clics pour créer votre devis avec photos. 1 clic pour faire signer. 1 clic pour convertir en facture. 1 clic pour envoyer par email. Pas plus.
              </p>
              <p className="text-base text-gray-400 italic mb-6">
                Si vous savez envoyer un SMS, vous savez utiliser DevisFast.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start mb-6">
                <Link to="/login?tab=inscription">
                  <Button className="w-full sm:w-auto bg-[#2563EB] hover:bg-[#1d4ed8] text-white rounded-full px-8 py-6 text-lg font-semibold" data-testid="hero-cta-btn">
                    Essayer 14 jours gratuits →
                  </Button>
                </Link>
                <Button variant="outline" className="w-full sm:w-auto border-white/20 text-white hover:bg-white/5 rounded-full px-8 py-6 text-lg flex items-center gap-2"
                  onClick={()=>{setShowVideoModal(true);if(window.plausible)window.plausible('Voir la démo');}}>
                  ▶ Voir la démo
                </Button>
              </div>
              <div className="flex flex-wrap justify-center md:justify-start gap-4 text-sm text-gray-400">
                <span className="flex items-center gap-1"><Check className="w-4 h-4 text-green-500"/>Sans carte bancaire à l'inscription</span>
                <span className="flex items-center gap-1"><Check className="w-4 h-4 text-green-500"/>Sans engagement</span>
                <span className="flex items-center gap-1"><Check className="w-4 h-4 text-green-500"/>Sur téléphone et sur ordinateur</span>
              </div>
            </div>
            <div className="hidden md:block"><PhoneMockup/></div>
          </div>
        </div>
      </section>

      {/* MOTION DEMO */}
      <section className="py-16 px-4 bg-[#0a0a0f]">
        <div className="max-w-5xl mx-auto"><MotionDemo/></div>
      </section>

      {/* LE DEVIS QUI PROUVE */}
      <section className="py-16 md:py-24 px-4 bg-[#0f0f17]">
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{fontFamily:"'Syne', sans-serif"}}>
                Le devis qui prouve.
              </h2>
              <p className="text-gray-400 text-lg mb-6">
                Ajoutez vos photos chantier directement depuis le terrain. Elles sont incluses dans le PDF envoyé au client.
              </p>
              <p className="text-gray-500 mb-8">
                Moins d'explications. Plus de clarté. Votre client voit l'état du chantier, comprend les prestations, et signe avec confiance.
              </p>
              <div className="space-y-4 mb-8">
                {[
                  {icon:"🌿",title:"Jardinier",desc:"Montrez l'état du jardin avant l'intervention."},
                  {icon:"🖌️",title:"Peintre",desc:"Ajoutez les murs abîmés ou les zones à reprendre."},
                  {icon:"🛠️",title:"Multiservices",desc:"Gardez une trace claire de l'état initial."},
                ].map((item,i)=>(
                  <div key={i} className="flex items-start gap-3">
                    <span className="text-2xl">{item.icon}</span>
                    <div>
                      <span className="font-semibold text-white">{item.title}</span>
                      <span className="text-gray-400"> — {item.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="inline-flex items-center gap-2 bg-[#2563EB]/10 border border-[#2563EB]/30 rounded-full px-4 py-2">
                <span className="text-[#2563EB] text-sm font-medium">Tout ce qu'il faut pour travailler pro. Rien de plus pour vous ralentir.</span>
              </div>
            </div>
            <div><ProofPhoneMockup/></div>
          </div>
        </div>
      </section>

      {/* BÉNÉFICES */}
      <section id="fonctionnalites" className="py-16 md:py-24 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{fontFamily:"'Syne', sans-serif"}}>Moins d'administratif, plus de terrain</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {icon:<Zap className="w-6 h-6"/>,title:"Devis en quelques minutes depuis le terrain",desc:"Créez un devis complet depuis votre téléphone, sur le chantier ou juste après. Sans attendre le soir."},
              {icon:<PenTool className="w-6 h-6"/>,title:"Le client signe quand il veut, comme il veut",desc:"Sur place depuis votre téléphone, ou à distance par email. Vous recevez le PDF signé instantanément."},
              {icon:<Briefcase className="w-6 h-6"/>,title:"Facture en 1 clic, sans ressaisie",desc:"Transformez un devis accepté en facture en un tap. Tout est déjà rempli."},
              {icon:<History className="w-6 h-6"/>,title:"Voyez tout d'un coup d'œil",desc:"Devis brouillon, envoyé, accepté, refusé. Factures envoyées, payées, en retard. Tout à jour, dès l'ouverture de l'app."},
              {icon:<Users className="w-6 h-6"/>,title:"Historique client complet",desc:"Retrouvez tous les devis et factures d'un client en quelques secondes, avec leur statut en temps réel."},
              {icon:<Smartphone className="w-6 h-6"/>,title:"Mobile et desktop",desc:"Sur le chantier depuis votre téléphone, au bureau depuis votre ordinateur. Toujours accessible."},
            ].map((item,i)=>(
              <div key={i} className="bg-[#1a1a24] rounded-2xl p-6 border border-white/5 hover:border-[#2563EB]/30 transition-colors">
                <div className="w-12 h-12 bg-[#2563EB]/10 rounded-xl flex items-center justify-center text-[#2563EB] mb-4">{item.icon}</div>
                <h3 className="font-semibold mb-2">{item.title}</h3>
                <p className="text-gray-400 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* POUR QUI */}
      <section className="py-16 md:py-24 px-4 bg-[#0f0f17]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{fontFamily:"'Syne', sans-serif"}}>Fait pour les artisans qui bossent sur le terrain</h2>
          <p className="text-gray-400 text-lg mb-10">DevisFast est fait pour les professionnels qui veulent aller vite, sans utiliser un outil compliqué.</p>
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            {metiers.map((m,i)=>(<span key={i} className="bg-[#1a1a24] border border-white/10 rounded-full px-4 py-2 text-sm flex items-center gap-2"><span>{m.icon}</span>{m.name}</span>))}
          </div>
          <p className="text-gray-500 italic">Si vous travaillez seul ou avec une petite équipe, DevisFast est fait pour vous.</p>
        </div>
      </section>

      {/* AVIS */}
      {reviews.length > 0 && (
        <section className="py-16 md:py-24 px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" style={{fontFamily:"'Syne', sans-serif"}}>
              Ils ont retrouvé leurs soirées.
            </h2>
            <p className="text-center text-gray-400 mb-12">Des artisans qui utilisent DevisFast au quotidien.</p>
            <div className="grid md:grid-cols-3 gap-6">
              {reviews.slice(0, 3).map((r, i) => (
                <div key={i} className="bg-[#1a1a24] rounded-2xl p-6 border border-white/5">
                  <div className="flex gap-1 mb-4">
                    {[1,2,3,4,5].map(s => (
                      <span key={s} style={{color: s <= r.rating ? '#f59e0b' : '#374151', fontSize:18}}>★</span>
                    ))}
                  </div>
                  <p className="text-gray-300 text-sm mb-5 leading-relaxed italic">"{r.text}"</p>
                  <div>
                    <div className="text-white font-semibold text-sm">{r.name}</div>
                    <div className="text-gray-500 text-xs mt-1">{r.job}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* PRICING */}
      <section id="tarifs" className="py-16 md:py-24 px-4 bg-[#0f0f17]">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" style={{fontFamily:"'Syne', sans-serif"}}>Simple et transparent</h2>
          <p className="text-center text-gray-400 mb-12">Sans engagement · Résiliable en 2 clics · 14 jours gratuits sans carte bancaire</p>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-[#1a1a24] rounded-2xl p-8 border border-white/10 flex flex-col">
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-gray-300 mb-1">Mensuel</h3>
                <div className="flex items-baseline gap-1"><span className="text-4xl font-bold">9,99€</span><span className="text-gray-400">/mois</span></div>
                <p className="text-gray-500 text-sm mt-2">Sans engagement, résiliable à tout moment.</p>
              </div>
              <ul className="space-y-3 mb-8 flex-1">
                {["Devis illimités","Factures illimitées","Signature électronique","PDF automatique","Gestion clients","Sur téléphone et ordinateur"].map((item,i)=>(<li key={i} className="flex items-center gap-2 text-sm text-gray-300"><Check className="w-4 h-4 text-green-500 flex-shrink-0"/><span>{item}</span></li>))}
              </ul>
              <Link to="/login?tab=inscription" className="block">
                <Button className="w-full bg-white/10 hover:bg-white/20 text-white rounded-full py-5 text-base font-semibold" data-testid="pricing-mensuel-btn">Essayer 14 jours gratuits</Button>
              </Link>
            </div>
            <div className="bg-gradient-to-br from-[#2563EB]/20 to-[#1a1a24] rounded-2xl p-8 border border-[#2563EB]/50 flex flex-col relative">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                <span className="bg-[#2563EB] text-white text-xs font-bold px-4 py-1.5 rounded-full whitespace-nowrap">⭐ 2 mois offerts</span>
              </div>
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-white mb-1">Annuel</h3>
                <div className="flex items-baseline gap-1"><span className="text-4xl font-bold">89€</span><span className="text-gray-400">/an</span></div>
                <p className="text-gray-400 text-sm mt-2">Soit <span className="text-white font-medium">7,42€/mois</span> — économisez 31€ par rapport au mensuel.</p>
              </div>
              <ul className="space-y-3 mb-8 flex-1">
                {["Devis illimités","Factures illimitées","Signature électronique","PDF automatique","Gestion clients","Sur téléphone et ordinateur"].map((item,i)=>(<li key={i} className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-green-500 flex-shrink-0"/><span>{item}</span></li>))}
              </ul>
              <Link to="/login?tab=inscription" className="block">
                <Button className="w-full bg-[#2563EB] hover:bg-[#1d4ed8] text-white rounded-full py-5 text-base font-semibold" data-testid="pricing-annuel-btn">Essayer 14 jours gratuits</Button>
              </Link>
            </div>
          </div>
          <div className="flex flex-wrap justify-center gap-4 mt-8 text-sm text-gray-400">
            <span className="flex items-center gap-1"><Check className="w-4 h-4 text-green-500"/>14 jours gratuits · Sans carte bancaire demandée</span>
            <span className="flex items-center gap-1"><Check className="w-4 h-4 text-green-500"/>Sans engagement</span>
            <span className="flex items-center gap-1"><Check className="w-4 h-4 text-green-500"/>Résiliable en 2 clics</span>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-16 md:py-24 px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{fontFamily:"'Syne', sans-serif"}}>Questions fréquentes</h2>
          <div className="space-y-4">
            {faqItems.map((item,i)=>(
              <div key={i} className="bg-[#1a1a24] rounded-xl border border-white/5 overflow-hidden">
                <button onClick={()=>setOpenFaq(openFaq===i?null:i)} className="w-full p-5 flex items-center justify-between text-left" data-testid={`faq-${i}`}>
                  <span className="font-medium pr-4">{item.q}</span>
                  {openFaq===i?<ChevronUp className="w-5 h-5 text-gray-400 flex-shrink-0"/>:<ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0"/>}
                </button>
                {openFaq===i&&<div className="px-5 pb-5 text-gray-400 border-t border-white/5 pt-4">{item.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="py-16 md:py-24 px-4 bg-gradient-to-br from-[#1a1a24] to-[#0f0f17]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{fontFamily:"'Syne', sans-serif"}}>
            Arrêtez de faire vos devis le soir et le week-end. Passez à DevisFast.
          </h2>
          <p className="text-gray-400 text-lg mb-8">Simple. Rapide. Depuis le téléphone. Tout ce qu'il faut pour arrêter de perdre du temps sur la paperasse.</p>
          <Link to="/login?tab=inscription">
            <Button className="bg-[#2563EB] hover:bg-[#1d4ed8] text-white rounded-full px-8 py-6 text-lg font-semibold" data-testid="final-cta-btn">Essayer 14 jours gratuits →</Button>
          </Link>
          <p className="text-gray-500 text-sm mt-6">✓ 14 jours gratuits · Sans carte bancaire · ✓ dès 7,42€/mois</p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-8 px-4 border-t border-white/5">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-[#2563EB] rounded-lg flex items-center justify-center"><Zap className="w-4 h-4 text-white"/></div>
              <span className="font-bold" style={{fontFamily:"'Syne', sans-serif"}}>DEVISFAST</span>
            </div>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-gray-400">
              <Link to="/mentions-legales" className="hover:text-white transition-colors">Mentions légales</Link>
              <Link to="/cgu" className="hover:text-white transition-colors">CGU</Link>
              <Link to="/cgv" className="hover:text-white transition-colors">CGV</Link>
              <Link to="/privacy" className="hover:text-white transition-colors">Confidentialité</Link>
              <a href="mailto:support@devisfast.fr" className="hover:text-white transition-colors">support@devisfast.fr</a>
              <Link to="/laisser-un-avis" className="hover:text-white transition-colors text-yellow-400">Donner mon avis ⭐</Link>
            </div>
            <p className="text-gray-500 text-sm">© 2026 DevisFast</p>
          </div>
        </div>
      </footer>

      {/* CTA FLOTTANT MOBILE */}
      <div className="fixed bottom-0 left-0 right-0 z-[90] md:hidden bg-[#0a0a0f]/95 backdrop-blur-md border-t border-white/10 px-4 py-3">
        <Link
          to="/login?tab=inscription"
          onClick={()=>{ if(window.plausible) window.plausible('CTA Flottant Mobile'); }}
        >
          <Button className="w-full bg-[#2563EB] hover:bg-[#1d4ed8] text-white rounded-full py-4 text-base font-semibold">
            Essayer 14 jours gratuits →
          </Button>
        </Link>
        <p className="text-center text-xs text-gray-500 mt-1.5">Sans carte bancaire · Sans engagement</p>
      </div>

      {showVideoModal&&(
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={()=>setShowVideoModal(false)}>
          <div className="relative w-full max-w-sm mx-auto" onClick={e=>e.stopPropagation()}>
            <button onClick={()=>setShowVideoModal(false)} className="absolute -top-10 right-0 text-white/70 hover:text-white text-sm">✕ Fermer</button>
            <video src="https://res.cloudinary.com/dzv8einm3/video/upload/v1778496303/Video_UGC_Hyper_Motion_Flow_complet_if1vyh.mp4" autoPlay controls playsInline loop className="w-full rounded-2xl shadow-2xl"/>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage;
